import { render, staticRenderFns } from "./transport.vue?vue&type=template&id=b35b8e84&scoped=true"
import script from "./transport.vue?vue&type=script&lang=js"
export * from "./transport.vue?vue&type=script&lang=js"
import style0 from "./transport.vue?vue&type=style&index=0&id=b35b8e84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b35b8e84",
  null
  
)

export default component.exports